// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/shopping-promo/shopping-promo.component.scss
// module id = 508
// module chunks = 0